/**
 * AppConfig Mapper
 *
 * Maps between AppConfig entity and AppConfigDTO
 */

import { AppConfig } from '../../domain/entities/AppConfig';
import type { AppConfigDTO } from '../dto/AppConfigDTO';

export class AppConfigMapper {
  static toDTO(entity: AppConfig): AppConfigDTO {
    return {
      id: entity.id,
      appName: entity.appName,
      appTagline: entity.appTagline,
      // Light mode logos
      logoOriginalUrl: entity.logoOriginalUrl,
      logoFaviconUrl: entity.logoFaviconUrl,
      logoSmallUrl: entity.logoSmallUrl,
      logoMediumUrl: entity.logoMediumUrl,
      logoLargeUrl: entity.logoLargeUrl,
      // Dark mode logos
      logoDarkOriginalUrl: entity.logoDarkOriginalUrl,
      logoDarkFaviconUrl: entity.logoDarkFaviconUrl,
      logoDarkSmallUrl: entity.logoDarkSmallUrl,
      logoDarkMediumUrl: entity.logoDarkMediumUrl,
      logoDarkLargeUrl: entity.logoDarkLargeUrl,
      primaryColor: entity.primaryColor,
      updatedAt: entity.updatedAt?.toISOString(),
      updatedBy: entity.updatedBy,
    };
  }

  static toEntity(dto: AppConfigDTO): AppConfig {
    return new AppConfig({
      id: dto.id,
      appName: dto.appName,
      appTagline: dto.appTagline,
      // Light mode logos
      logoOriginalUrl: dto.logoOriginalUrl,
      logoFaviconUrl: dto.logoFaviconUrl,
      logoSmallUrl: dto.logoSmallUrl,
      logoMediumUrl: dto.logoMediumUrl,
      logoLargeUrl: dto.logoLargeUrl,
      // Dark mode logos
      logoDarkOriginalUrl: dto.logoDarkOriginalUrl,
      logoDarkFaviconUrl: dto.logoDarkFaviconUrl,
      logoDarkSmallUrl: dto.logoDarkSmallUrl,
      logoDarkMediumUrl: dto.logoDarkMediumUrl,
      logoDarkLargeUrl: dto.logoDarkLargeUrl,
      primaryColor: dto.primaryColor,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
      updatedBy: dto.updatedBy,
    });
  }
}
